/**
 * StepIndicator
 *
 * Extracted from LanguageTestModal — renders the step progress bar
 * at the top of the modal.
 */

import { cn } from '@tonnie/foundation';
import { useTranslation } from '@tonnie/locale';
import { CheckCircle2 } from '@tonnie/assets';

import { STEP_LABEL_KEYS } from './language-test.constants';

export function StepIndicator({ currentIdx }: { currentIdx: number }) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-1">
      {STEP_LABEL_KEYS.map((key, idx) => (
        <div key={key} className="flex items-center flex-1">
          <div className="flex items-center gap-2 flex-1">
            <div
              className={cn(
                'w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold shrink-0 transition-all duration-300',
                idx < currentIdx
                  ? 'bg-success text-success-foreground'
                  : idx === currentIdx
                    ? 'bg-primary text-primary-foreground shadow-md'
                    : 'bg-muted text-muted-foreground'
              )}
            >
              {idx < currentIdx ? <CheckCircle2 className="w-4 h-4" /> : idx + 1}
            </div>
            <span
              className={cn(
                'text-xs font-medium whitespace-nowrap',
                idx === currentIdx ? 'text-foreground' : 'text-muted-foreground'
              )}
            >
              {t(key)}
            </span>
          </div>
          {idx < STEP_LABEL_KEYS.length - 1 && (
            <div
              className={cn(
                'h-0.5 flex-1 mx-2 rounded transition-colors duration-300',
                idx < currentIdx ? 'bg-success' : 'bg-border'
              )}
            />
          )}
        </div>
      ))}
    </div>
  );
}
